/**
 * Common Domain Schemas
 *
 * Multi-tenant schema shared across auth/session code. The rest of this file's
 * original "shared base patterns" scaffold (IDs, pagination, addresses, files,
 * notifications, etc.) was never wired to any real validator and was removed
 * in DEV2-1271 — only the inferred `Tenant` type is actually consumed
 * (AuthProvider, session-manager); the schema itself is not run against API
 * responses today.
 */

import { z } from 'zod';

const idSchema = z.string().min(1, 'ID is required');
const slugSchema = z.string().regex(/^[a-z0-9-]+$/, 'Invalid slug format');
const dateSchema = z.date();

export const tenantSchema = z.object({
  tenantId: idSchema,
  name: z.string().min(1, 'Tenant name is required'),
  slug: slugSchema,
  domain: z.string().optional(),
  settings: z.record(z.string(), z.any()).optional(),
  isActive: z.boolean().default(true),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export type Tenant = z.infer<typeof tenantSchema>;
